import { ErrorOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import './styleClubLinks.css';

function ErrorMessageClubLinks() {
  const { t } = useTranslation('app');

  return (
    <div className="estab-loading-info">
      <ErrorOutline style={{ color: 'red', fontSize: '5rem' }} />
      <h1>{t('errors.try_again')}</h1>
    </div>
  );
}

export default ErrorMessageClubLinks;
